<template>
    <div class="loading-screen" role="status" aria-live="polite">
        <span class="indicator" aria-hidden="true"></span>
        <p>{{ message }}</p>
    </div>
</template>

<script>
export default {
    name: "LoadingScreen",
    props: {
        message: {
            type: String,
            required: true,
        },
    },
};
</script>
